import React, { useEffect, useState, useMemo, useRef } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom";
import moment from "moment";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

export default function ClientCasinoDetailsPopup() {
  const { transid } = useParams();
  const [data, setData] = useState(null);
  const [summarydata, setSummaryData] = useState(null);
  const [betSummary, setBetSummary] = useState({});
  const [winAmount, setWinAmount] = useState(0);
  const [comissionAmount, setComissionAmount] = useState(0);
  const [winnerName, setWinnerName] = useState(0);
  const [betAmount, setbetAmount] = useState(0);

  const [resultsData, setResultsData] = useState(null);
  const [catMid, setCatMid] = useState("");
  const [marketType, setMarketType] = useState("");
  const [Dealer, setDealer] = useState("");
  const [game_type, setGameType] = useState("");

  const [uname, setUname] = useState("");

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  useEffect(() => {
    const fetchBetDetails = async () => {
      const response = await axiosInstance.get(
        `profit-loss/trans-details/${transid}`
      );
      let winAmount = response?.data.winAmount;
      let comission = response?.data.comission;
      setWinAmount(winAmount);
      setComissionAmount(comission);
      setDealer(response?.data?.bet?.dealer);

      setUname(response?.data?.bet?.uname);
      setbetAmount(response?.data?.bet?.player_Bet_amount);

      setSummaryData(response.data.bet);

      setBetSummary(response?.data?.bet?.bet_summary[0]);
      console.log(response.data);

      setData(response.data.bet.betList);

      console.log("FULL RESPONSE", response.data);
      console.log("BET", response.data.bet);

      setResultsData(response.data.bet.rateJson);

      setWinnerName(response.data.bet?.rateJson?.resultTxt);

      setCatMid(response.data.bet.cat_mid);

      setMarketType(response?.data?.bet?.market_type);
      setGameType(response?.data?.bet?.game_type);
      setDealer(response.data.bet.dealer);
      setIsLoading(false);

      if (marketType === 11) {
        //setPriceValue(betSummary?.rate);
      }
    };
    fetchBetDetails();
  }, []);

  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <div className="animated fadeIn" style={{ margin: 0 }}>
        <div className="container-fluid p-0">
          {/* small style overrides are added below using a standard <style> element */}
          <div className="row w-100 m-0">
            <div className="col-12 p-0">
              <div className="card">
                <div className="card-header">
                  <h5 className="m-0 d-flex align-items-center">
                    <span className="heading_css">{summarydata?.remark}</span>
                  </h5>
                </div>

                <div className="card-body">
                  <div class="card-body">
                    <table class="table table-hover">
                      <tbody>
                        <tr>
                          <td class="col-sm-3">UserName</td>
                          <td class="col-sm-9">{uname}</td>
                        </tr>
                        <tr>
                          <td>Date</td>
                          <td>
                            <span class="market-time">
                              {moment(summarydata?.created_date).format(
                                "MM/DD/YYYY HH:mm:ss a"
                              )}
                            </span>
                            <span
                              class="d-none utctime"
                              data-format="M/D/YYYY hh:mm:ss a"
                              data-target="time"
                            >
                              {moment(summarydata?.created_date).format(
                                "MM/DD/YYYY HH:mm:ss a"
                              )}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td class="col-sm-3">Result</td>
                          <td class="col-sm-9">
                            <strong>{winAmount > 0 ? "WON" : "LOSS"}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="col-sm-3">Bet Amount</td>
                          <td class="col-sm-9">{formatTruncate(betAmount)}</td>
                        </tr>
                        <tr>
                          <td class="col-sm-3">P &amp; L</td>
                          <td class="col-sm-9">{formatTruncate(winAmount)}</td>
                        </tr>
                        <tr>
                          <td class="col-sm-3">Commission</td>
                          <td class="col-sm-9">-{comissionAmount}</td>
                        </tr>
                        <tr class="success">
                          <td class="col-sm-3">Net P &amp; L</td>
                          <td class="col-sm-9">
                            <strong>{formatTruncate(winAmount)}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SAFE CSS (no dangerouslySetInnerHTML) */}
      <style>{`

table.dataTable.no-footer {
  border-bottom: 0px solid #111;
}
.table.dataTable thead th, table.dataTable thead td{
  border-bottom: 1px solid #dee2e6;
}
.dt-paging-button { 
  padding: .5em 0px; 
}

        .table { width: 100% !important; }
        .table.table-striped td, .table.table-striped th {
          padding: 4px 8px !important;
          font-size: 16px;
          white-space: normal !important;
          vertical-align: middle;
        }
        
        .pagination {
          
          float: right;
      }
        .toggle-row {
          border: none;
          cursor: pointer;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          font-weight: 700;
          font-size: 14px;
          color: #fff;
          background:#337ab7;
          display:flex;
          align-items:center;
          justify-content:center;
          font-family: 'Courier New', Courier, monospace;
          border: 2px solid white;
          box-shadow: 0 0 3px #444;
           
        }
        .toggle-open { background:#dc3545 !important; }
        .summary-table th { text-align:left; border: 0; padding: 0.25rem 0; }
        @media (max-width: 640px) {
          .pagination {
          
            float: unset;
        }
        .dt-info {
          float: unset;
          
      }
          .summary-table th { display:block; width:100%; white-space:normal; font-size:14px; }
          .table.table-striped td, .table.table-striped th { font-size:14px !important; padding:6px 6px !important; }
        }
        .heading_css {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
          margin-bottom: .5rem;
          line-height: 1.2;
          font-size: 1.5rem;
          font-weight: 500;
          padding: .75rem 1.25rem;
         
        }

        .txt_css {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        }



        table.dataTable.dtr-inline.collapsed tbody tr td.dtr-control:before,
        table.dataTable.dtr-inline.collapsed tbody tr th.dtr-control:before 
        {
          height: 14px;
    width: 14px;
    margin-right: .5em;
    display: inline-block;
    content: "+";
    color: white;
    border: 2px solid white;
    border-radius: 14px;
    box-shadow: 0 0 3px #444;
    box-sizing: content-box;
    text-align: center;
    text-indent: 0 !important;
    font-family: 'Courier New', Courier, monospace;
    line-height: 14px;
    background-color: #337ab7;
    float: inline-start;
           
        }

        div.dt-container .dt-paging .dt-paging-button {
          padding: 4px 0px;
        }

        div.dt-container .dt-paging .dt-paging-button:hover {
          /* color: white !important; */
          border: 0px solid #111;
          background-color: transparent
          background: unset;
      }

/* Open row */
table.dataTable.dtr-inline.collapsed > tbody > tr.dtr-expanded > td.dtr-control:before, table.dataTable.dtr-inline.collapsed > tbody > tr.dtr-expanded > th.dtr-control:before {
  content: '-';
  background-color: #d33333;
  border: 2px solid white;
  float: inline-start;
}
      `}</style>
    </>
  );
}
